/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Loop_2_DescInputs */

const en_mk_loop_2_desc = /** @type {(inputs: Mk_Loop_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The starting commit is saved in .bystep/. Diff, duration and cost are measured from here.`)
};

const id_mk_loop_2_desc = /** @type {(inputs: Mk_Loop_2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit awal disimpan di .bystep/. Diff, durasi, dan biaya dihitung dari sini.`)
};

/**
* | output |
* | --- |
* | "The starting commit is saved in .bystep/. Diff, duration and cost are measured from here." |
*
* @param {Mk_Loop_2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_loop_2_desc = /** @type {((inputs?: Mk_Loop_2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Loop_2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_loop_2_desc(inputs)
	return en_mk_loop_2_desc(inputs)
});